<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Production Stages List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your production stages notification here</nz-page-header-subtitle>
      <nz-page-header-extra>
        @if (permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">
            Add New
          </button>
        }
      </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <div style="padding: 8px; float: right">
      <input type="text" style="width: 250px; margin-right: 8px" nz-input placeholder="Search stage name "
        [(ngModel)]="searchValue" (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()" />

      <button nz-button nzSize="small" nzType="primary" (click)="search()" style="margin-right: 8px">
        Search
      </button>

      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()">
        <i nz-icon nzType="export" nzTheme="outline"></i> Export
      </button>
    </div>

    <nz-table [nzPageSize]="100" style="width: 100%" nzBordered [nzScroll]="{ x: '1200px', y: '515px' }" nzSize="small"
      #basicTable [nzData]="this.NotificationList" [nzLoading]="isTableLoading">
      <thead>
        <tr>
          <th nzWidth="50px" nzLeft>S.No</th>
          <th nzWidth="100px">Sales Order Stages</th>
          <th nzWidth="50px">Only Internal</th>
          <th nzWidth="50px">Only Customer</th>
          <th nzWidth="100px">Added By</th>
          <th nzWidth="100px">Added Date</th>
          <th nzWidth="100px" nzRight style="text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (data of NotificationList; track data; let i = $index) {
          <tr>
            <td nzLeft>{{ data.SerialNumber }}</td>
            <td>{{ data.SaleOrderStages }}</td>
            <td>{{ data.OnlyInternal }}</td>
            <td>{{ data.OnlyCustomer }}</td>
            <td>{{ data.AddedBy }}</td>
            <td>{{ data.AddedDate | DatetimeConverter }}</td>
            <td nzRight style="text-align: center">
              @if (permission.Edit) {
                <button class="btn btn-sm btn-light-primary" (click)="editNotification(data)">
                  Edit
                </button>
              }
              &nbsp;
              @if (permission.Delete) {
                <button class="btn btn-sm btn-light-danger" (click)="handleDelete(data)">
                  Delete
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '80px' }" nzWidth="600px" [nzTitle]="modalTitle" [nzContent]="modalContent"
      [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">
      <ng-template #modalTitle>{{ NotificationTitle }}</ng-template>

      <ng-template #modalContent>
        <form nz-form>
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Sales Order Stage</nz-form-label>
            <nz-form-control [nzSpan]="14" nzValidateStatus="success">
              <nz-select name="select-error1" nzShowSearch [(ngModel)]="NewNotificationStage.SaleOrderStages">
                <nz-option nzValue="0" nzLabel="Select Sales Order Stage"></nz-option>
                @for (s of OrderStages; track s) {
                  <nz-option [nzValue]="s.value" [nzLabel]="s.name"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Only Internal</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input type="checkbox" (change)="setInternal($event)" [(ngModel)]="NewNotificationStage.OnlyInternal"
                name="OnlyInternal" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Only Customer</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input type="checkbox" [(ngModel)]="NewNotificationStage.OnlyCustomer" name="OnlyCustomer" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>WhatsApp Template Name</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select name="select-error1" nzShowSearch [(ngModel)]="NewNotificationStage.WhatsAppTemplateMasterId" nzPlaceHolder="Select Template">
                @for (s of WhatsAppTemplateList; track s) {
                  <nz-option [nzValue]="s.WhatsAppTemplateMasterId" [nzLabel]="s.ProviderTemplateName"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-template>

      <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">
          Cancel
        </button>
        @if (permission.Add || permission.Edit) {
          <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoading">
            Save Notification
          </button>
        }
      </ng-template>
    </nz-modal>
  </div>
</div>